export default {
	props: {
		disabled: {
			type: Boolean,
			default: () => false
		},
		name: {
			type: String,
			required: true
		}
	},
	inject: ["validate", "form"],
	beforeMount() {
		this.$store.commit("form_field_register", {
			form: this.form,
			field: this.name
		});
	},
	beforeDestroy() {
		this.$store.commit("form_field_unregister", {
			form: this.form,
			field: this.name
		});
	},
	computed: {
		meta() {
			return this.$store.getters.formGetFieldMeta(this.form, this.name);
		},
		value() {
			return this.$store.getters.formFieldValue(this.form, this.name);
		},
		error() {
			return this.$store.getters.formFieldError(this.form, this.name);
		},
		showError() {
			return (
				this.$store.getters.formHasSubmitted(this.form) &&
				this.meta.touched &&
				!!this.error
			);
		},
		hasContent() {
			return !!this.$slots.default;
		}
	},
	methods: {
		extractValue(e) {
			return e && e.currentTarget ? e.currentTarget.value.trim() : e;
		},
		input(e) {
			this.$store.commit("form_field_change", {
				form: this.form,
				field: this.name,
				value: this.extractValue(e)
			});
		},
		blur(e) {
			this.$store.commit("form_field_leave", {
				form: this.form,
				field: this.name,
				value: this.extractValue(e)
			});
			this.validate(this.name);
		},
		focus(e) {
			this.$store.commit("form_field_focus", {
				form: this.form,
				field: this.name,
				value: this.extractValue(e)
			});
		},
		reset() {
			this.$store.commit("form_field_reset", {
				form: this.form,
				field: this.name
			});
		}
	}
}; // eslint-disable-line
